import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useDemoModal } from "@/contexts/DemoModalContext";
import { useToast } from "@/hooks/use-toast";

const RequestDemoModal = () => {
  const { isOpen, closeDemoModal } = useDemoModal();
  const { toast } = useToast();

  const handleDemoRequest = () => {
    // Open Typeform in a new tab
    window.open('https://ove9zyb57n9.typeform.com/to/cEn6fYrU', '_blank');
    
    // Show confirmation toast
    toast({
      title: "Demo Request Sent",
      description: "We'll be in touch shortly to schedule your personalized demo.",
    });

    // Close the modal
    closeDemoModal();
  };

  return (
    <Dialog open={isOpen} onOpenChange={closeDemoModal}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Request a Demo</DialogTitle>
          <DialogDescription>
            See how NAVISA can transform your immigration practice
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <p className="text-sm text-muted-foreground">
            Our team will walk you through:
          </p>
          <ul className="list-disc list-inside text-sm text-muted-foreground space-y-2">
            <li>Client onboarding automation</li>
            <li>Document management system</li>
            <li>Case tracking and analytics</li>
            <li>Client communication tools</li>
            <li>Compliance and audit features</li>
          </ul>
        </div>
        <div className="flex justify-end">
          <Button onClick={handleDemoRequest} className="w-full">
            Schedule Demo
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default RequestDemoModal;